var React = require('react');

function ArrowGrowGreen (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#12dfc7","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M18 7h3v3","key":0}),React.createElement("path",{"d":"m4 17 6.376-5.715 4.25 2.143L21 7","key":1})]));
}

ArrowGrowGreen.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ArrowGrowGreen;

ArrowGrowGreen.default = ArrowGrowGreen;
